<template>
    <div v-loading="loading">
        <h1>Días desde el último accidente</h1>
        <h3>({{lastAccident.accidentDescriptor}})</h3>
        <countup :date="lastAccident.date"></countup>
        <h1 class="mt-5 pt-3">Adiós Sign, que la fuerza te acompañe </h1>
        <countup :date="byeSignMTFBWY"></countup>
        <div class="reset-container">
            <input v-model="newAccidentDescriptor" placeholder="Motivo de tu sufrimiento"></input>
            <button v-on:click="newAccident()" :disabled="loading">Reiniciar contador</button>
        </div>
    </div>
</template>

<script>
    import Axios from "../utils/http/Axios";
    import countup from "../components/countup";

    export default {
        name: "accidents",
        components: {countup},
        data:_=>{
            return {
                lastAccident: { accidentDescriptor:'', date:new Date() },
                loading: true,
                byeSignMTFBWY: new Date("2030-12-31T13:00:00.000Z"),
                newAccidentDescriptor:''
            }
        },
        mounted() {
            this.getAccidents();
        },
        methods:{
            getAccidents(){
                return Axios.getInstance().get('/api/accidents').then(res=>{
                    this.lastAccident = res.data.lastAccident;
                    this.lastAccident.date = new Date(res.data.lastAccident.date);
                    this.loading=false;
                }).catch(err=>{
                    console.error(err);
                    this.lastAccident = {
                        date: new Date(),
                        accidentDescriptor: "Se rompió la qzone"
                    }
                    this.loading=false;
                });
            },
            newAccident(){
                this.loading=true;
                return Axios.getInstance().post('/api/accident', {
                        accidentDescriptor: this.newAccidentDescriptor || "Motivo desconocido"
                    }).then(res=>{
                    this.getAccidents()
                }).catch(err=>{
                    console.error(err);
                    this.lastAccident = {
                        date: new Date(),
                        accidentDescriptor: "Se rompió la qzone"
                    }
                    this.loading=false;
                });
            }
        }

    }
</script>

<style scoped>
    .reset-container {
        position: fixed;
        right: 3px;
        bottom: 3px;
    }
    .reset-container input {
        border: #2c3e50 2px solid;
        border-right: 0;
        border-bottom-left-radius: 7px;
        border-top-left-radius: 7px;
        padding-left: 5px;
    }
    .reset-container button {
        border: #2c3e50 2px solid;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        border-left-width: 1px;

        background-color: #EEEEF0;
        color: #2c3e50;
    }
    .reset-container button:active {
        background-color: #DDDDE0;
    }
</style>